<template>
  <section
    class="steps"
    v-if="isVisible"
  >
    <ul>
      <nav-steps-links
        v-for="step in stepping.steps"
        :step="step"
        :current-step="stepping.currentStep"
        :key="step.order"
      />
    </ul>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import NavStepsLinks from './NavStepsLinks'

export default {
  components: {
    NavStepsLinks,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapState({
      stepping: (state) => state.stepping,
    }),
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.steps {
  align-items: center;
  background: white;
  display: flex;
  justify-content: center;
  padding: 0 9px;

  @include teq-breakpoint($medium) {
    padding: 15px 0;
  }

  > ul {
    counter-reset: counter-steps;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    width: 100%;

    @include teq-breakpoint($medium) {
      max-width: calc(100% - 186px);
    }
  }
}
</style>
